import { render } from "./TvmSuggestions.vue?vue&type=template&id=0d11a90f&scoped=true"
import script from "./TvmSuggestions.js?vue&type=script&lang=js&external"
export * from "./TvmSuggestions.js?vue&type=script&lang=js&external"

import "./TvmSuggestions.vue?vue&type=style&index=0&id=0d11a90f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d11a90f"]])

export default __exports__